import type { AdapterMeta } from "@repo/adapter-core";

export const TOOP_AND_TOOP_META: AdapterMeta = {
  slug: "toop-and-toop",
  name: "Toop & Toop",
  baseUrl: "https://www.toop.com.au",
  description: "Adelaide premium agency with sold property coverage in SA.",
  supportedStates: ["SA"],
  urlPattern: /toop\.com\.au\/[a-z0-9-]+-\d+/i,
  sourceType: "agency",
};
